const actions = {
    GET_DAILY_PLAN_REQUEST_LIST_FOR_SOCKET: "GET_DAILY_PLAN_REQUEST_LIST_FOR_SOCKET",

    GET_SIM_SWAP_REQUEST_FOR_SOCKET: "GET_SIM_SWAP_REQUEST_FOR_SOCKET",

    GET_ACTIVATION_REQUEST_LIST_FOR_SOCKET: "GET_ACTIVATION_REQUEST_LIST_FOR_SOCKET",

    GET_MSISDN_POOL_DATA_FOR_SOCKET: "GET_MSISDN_POOL_DATA_FOR_SOCKET",

    GET_PENDING_DPRCOUNT_DEALER_SOCKET: "GET_PENDING_DPRCOUNT_DEALER_SOCKET",

    GET_LOCKED_DAILY_PALN_ACTIVATION_SOCKET: "GET_LOCKED_DAILY_PALN_ACTIVATION_SOCKET",

    GET_LOCKED_SIM_SWAP_REQUEST_SOCKET: "GET_LOCKED_SIM_SWAP_REQUEST_SOCKET",

    GET_LOCKED_ACTIVATION_REQUEST_SOCKET: "GET_LOCKED_ACTIVATION_REQUEST_SOCKET",

    getLockedActivationRequestForSocket: () => ({
        type: actions.GET_LOCKED_ACTIVATION_REQUEST_SOCKET,
    }),

    getLockedSIMSwapRequestForSocket: () => ({
        type: actions.GET_LOCKED_SIM_SWAP_REQUEST_SOCKET,
    }),

    getLockedDailyPlanActivationForSocket: () => ({
        type: actions.GET_LOCKED_DAILY_PALN_ACTIVATION_SOCKET,
    }),

    getPendingDPRCountForSocketList: () => ({
        type: actions.GET_PENDING_DPRCOUNT_DEALER_SOCKET,
    }),

    getDailyPlanRequestListForSocket: (searchData) => ({
        type: actions.GET_DAILY_PLAN_REQUEST_LIST_FOR_SOCKET,
        payload: { searchData }
    }),

    getSimSwapRequestForSocket: (searchData) => ({
        type: actions.GET_SIM_SWAP_REQUEST_FOR_SOCKET,
        payload: { searchData }
    }),

    getActivationRequestForSocketList: (searchData) => ({
        type: actions.GET_ACTIVATION_REQUEST_LIST_FOR_SOCKET,
        payload: { searchData }
    }),

    getMsisdnPoolForSocketList: (searchData) => ({
        type: actions.GET_MSISDN_POOL_DATA_FOR_SOCKET,
        payload: { searchData }
    }),
};

export default actions;